import {create} from "zustand";
import axios from "axios";
import {message} from "antd";

export let useBooks = create((set, get) => ({
    books: [],
    booksLimit: [],
    cats: [],
    authors: [],
    db: '',
    loader: false,
    getBooks: () => {
        axios.get('books').then(res => {
            if (res.status === 200) {
                set({books: res.data})
            }
        })
    },
    getBooksLimit: () => {
        axios.get('bookslimit').then(res => {
            if (res.status === 200) {
                set({booksLimit: res.data})
            }
        })
    },
    getCats: ()=>{
        axios.get('bookcats').then(res => {
            if (res.status === 200) {
                set({cats: res.data})
            }
        })
    },
    getAuthors: ()=>{
        axios.get('bookautors').then(res => {
            if (res.status === 200) {
                set({authors: res.data})
            }
        })
    },

}))